module.exports = __webpack_public_path__ + "static/pic05-0fb17a9c2e54a09bf8d5a2e239797ba1.jpg";